"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATCGroup = exports.ATC = void 0;
var atc_1 = require("./atc");
Object.defineProperty(exports, "ATC", { enumerable: true, get: function () { return __importDefault(atc_1).default; } });
var atc_group_1 = require("./atc.group");
Object.defineProperty(exports, "ATCGroup", { enumerable: true, get: function () { return __importDefault(atc_group_1).default; } });
//# sourceMappingURL=index.js.map